<template>
  <Select v-model="selected" @on-select="handleSelect" :clearable="clearable" :placeholder="$t('order.search_accounting_belongs')">
    <Option v-for="p in accountCompanies" :key="p.name" :value="p.name">{{ p.label }}</Option>
  </Select>
</template>

<script>
export default {
  name: 'AccountCompanySelect',
  props: {
    clearable: Boolean
  },
  data () {
    return {
      selected: this.$attrs.value,
      accountCompanies: [
        {
          name: 'NexGroup Inc.',
          label: 'NexGroup Inc.',
          address: '<p>100 TradeCenter, Suite G-700</p><p>MA US</p>' },
        {
          name: 'NEXPCB LIMITED',
          label: 'NEXPCB LIMITED',
          address: '<p>Rm. 19C, Lockhart Ctr., 301- 307 Lockhart Rd., Wan Chai, Hong Kong</p>'
        },
        {
          name: 'Ningbo High-tech Zone LADDER Science Co., Ltd',
          label: 'Ningbo High-tech Zone LADDER Science Co., Ltd',
          address: '<p>NINGBO HIGH-TECH ZONE <br/>LADDER SCIENCE CO.,LTD <br/>LingyunIndustryParkNo.1177LingyunRoad, <br/>BuildingNo.1,  2nd-Floor Ningbo  <br/>Zhejiang Province China</p>'
        },
        {
          name: '宁波研诚进出口有限公司',
          label: '宁波研诚进出口有限公司',
          address: ''
        }
      ]
    }
  },
  watch: {
    '$attrs.value': function (newVal) {
      this.selected = this.$attrs.value
    }
  },
  mounted() {
    this.handlePoplateSelected()
  },
  methods: {
    handlePoplateSelected() {
      if (this.selected) {
        this.handleEmitSelectedCompany()
      }
    },
    handleSelect (item) {
      this.$emit('input', item.value)
      this.$nextTick(() => {
        this.handleEmitSelectedCompany()
      })
    },
    handleEmitSelectedCompany() {
      let company = _.find(this.accountCompanies, (company) => {
        return this.selected === company.name
      })
      this.$emit('on-select', company)
    }
  }
}
</script>
